var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('k-form',{ref:"form",attrs:{"validator":_vm.createIssueTicketValidator},on:{"submit":_vm.createTicket}},[_c('create-issue-ticket-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }